import React from 'react'
import { RichTextInput } from './RichTextInput'
import { InlineInput, type InlineInputContentOptions, type InlineInputProps } from '../InlineInput'
import { EmptyContent } from '@ztechapps/webui.util'
import { BusyButton, SaveCancelButtons } from '@ztechapps/webui.button'
import { RichTextDisplay } from './RichTextDisplay'
import { Container } from 'react-bootstrap'

export const RichTextInlineInput = ({
  parentInputComponent,
  displayContent,
  emptyContent,
  editContent,
  inputProps,
  ...rest
}: InlineInputProps) => {
  displayContent =
    displayContent ??
    ((e) => (
      <Container>
        {/* trustedSource: this displays the value the current user just entered through this same
            editor — self-authored input, not attacker-reachable */}
        <RichTextDisplay contentHtml={e} trustedSource />
      </Container>
    ))

  const ParentInput = parentInputComponent || InlineInput
  emptyContent =
    emptyContent ??
    ((onClick) => (
      <EmptyContent
        message="The content is still empty."
        subMessage="You can start adding new content by clicking the button below."
        action={<BusyButton text="Add new content" onClick={onClick} icon="edit" />}
      />
    ))

  editContent =
    editContent ??
    (({ setNewValue, saveNow, cancelNow, canEdit, submitting, ...rest }: InlineInputContentOptions) => {
      return (
        <React.Fragment>
          <div className="mb-2">
            <SaveCancelButtons isBusy={submitting} disabled={!canEdit} onSave={saveNow} onCancel={cancelNow} />
          </div>

          <RichTextInput {...rest} disabled={!canEdit} onChange={(e) => setNewValue(e)} {...inputProps} />
        </React.Fragment>
      )
    })

  return (
    <ParentInput
      {...{
        ...rest,
      }}
      emptyContent={emptyContent}
      displayContent={displayContent}
      editContent={editContent}
    />
  )
}
